import { useState } from 'react'
import { Grid2, Typography } from '@mui/material'
import { Field } from 'formik'
import TableFilterTemplate from '../../../shared/utils/TableFilterTemplate';
import { DateFormField } from '../../../shared/components/formfields/DataFormField';
import { useAdminOnboardingReport } from '../../../assets/api/useAdminApi';

const OnBoardingReports = () => {
    const [filters, setFilters] = useState({});
    const { data: onboardingReports, isLoading: isOnboardingReportLoading } = useAdminOnboardingReport(filters)

   

    const onboardingReportColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "zone_name",
            headerName: "Zone Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "cluster_name",
            headerName: "Cluster Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "zone_head_name",
            headerName: "Zone Head",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "no_of_calls",
            headerName: "Total Calls",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
          {
            field: "no_of_responses",
            headerName: "Total Responses",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
          {
            field: "positive",
            headerName: "Total Positive",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
         {
            field: "onboarded",
            headerName: "Total Onboarded",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
          {
            field: "is_active",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value===1?"Active":"Inactive"}</Typography>,
        }
    ];

    return (
        <>
            <TableFilterTemplate
                title="Onboarding Report"
                columns={onboardingReportColumn}
                rowsData={onboardingReports?.data || []}
                isLoading={isOnboardingReportLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}

                renderFilterFields={({ values }) => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="from"
                                component={DateFormField}
                                label="Start Date"
                                maxDate={values?.to || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="to"
                                component={DateFormField}
                                label="End Date"
                                minDate={values?.from || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />
        </>
    )
}

export default OnBoardingReports